import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import Popup, { PopupActions, PopupButton, PopupContent, PopupHeading, } from "@/react/components/Common/Popup";
// The checkbox wording and the terms of purchase as they were when the order
// was placed (EPMS-2528).
const OrderTermsConsentText = ({ termsConsent }) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { paragraph: true }, termsConsent.consentText),
        React.createElement(Typography, { variant: "subtitle2" }, t("Terms of purchase")),
        React.createElement(Typography, { component: "div", dangerouslySetInnerHTML: {
                __html: termsConsent.termsText.replace(/\n/g, "<br/>"),
            } })));
};
// The order details are already inside an accordion, so the consent opens in a
// popup instead of nesting another one.
const OrderTermsConsent = ({ termsConsent }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    return (React.createElement(Box, { sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 2,
            mt: 2,
        } },
        React.createElement(Typography, { variant: "body2", sx: { textAlign: "right" } },
            React.createElement(Trans, null, "Terms of purchase confirmed at order completion")),
        React.createElement(Button, { variant: "outlined", color: "primary", sx: { flexShrink: 0 }, onClick: () => setOpen(true) }, t("View details")),
        open && (React.createElement(Popup, { onClose: () => setOpen(false) },
            React.createElement(PopupHeading, { subHeading: t("When placing the order, you confirmed:") }, t("Terms of purchase")),
            React.createElement(PopupContent, null,
                React.createElement(OrderTermsConsentText, { termsConsent: termsConsent })),
            React.createElement(PopupActions, null,
                React.createElement(PopupButton, { fullWidth: true, onClick: () => setOpen(false) }, t("Close")))))));
};
export default OrderTermsConsent;
